import { useState, useEffect } from 'react';
import axiosInstance from '../axiosInstance';

export const useFormData = (requestProgressId, persona) => {
  const parentLink = persona === "customer" ? "stages/parent/enduser" : "stages/parent";
  const childrenLink = persona === "customer" ? "stages/children/enduser" : "stages/children";

  const [parentStage, setParentStage] = useState({});
  const [filledForm, setFilledForm] = useState();
  const [subForms, setSubForms] = useState([]);
  const [children, setChildren] = useState([]);
  const [requestProgress, setRequestProgress] = useState([]);
  const [isIRB, setIsIRB] = useState(false);
  const [loading, setLoading] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [roleName, setRoleName] = useState("");

  useEffect(() => {
    const fetchStage = async () => {
      if (!requestProgressId) return;
      
      setLoading(true);
      try {
        const resp = await axiosInstance.get(`/api/stages/${parentLink}/${requestProgressId}`);
        setParentStage(resp.data.parentStage);
        setSubForms(resp.data.parentStage.Stage.Form.subforms);
        setRequestProgress(resp.data.requestProgress);
        setFilledForm(resp.data.filledForm);
        setIsIRB(resp.data.isIRB);
        setRoleName(resp.data.parentStage.Stage.Role.name);
        // Extract request_id from requestProgress
        if (resp.data.requestProgress?.request_id) {
          setRequestId(resp.data.requestProgress.request_id);
        }
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStage();
  }, [requestProgressId, parentLink]);

  useEffect(() => {
    const fetchStageChildren = async () => {
      if (!parentStage.Stage?.id) return;

      try {
        const resp = await axiosInstance.get(`/api/stages/${childrenLink}/${parentStage.Stage.id}`);
        let childrenData = resp.data.children;
        console.log("childrenData =>", resp.data);
        if (isIRB) {
          childrenData = [...childrenData, {
            id: 'irb',
            approval_type_id: 4,
            ApprovalType: {
              id: 4,
              name: 'Send To Reviewers'
            },
            wf_version_id: parentStage.wf_version_id
          }];
        }
        setChildren(childrenData);
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchStageChildren();
  }, [parentStage.Stage?.id, isIRB, childrenLink]);

  return {
    parentStage,
    filledForm,
    subForms,
    children,
    requestProgress,
    isIRB,
    loading,
    requestId,
    roleName,
  };
}; 